import useV2Vaults from '@/application/read/migrate/useV2Vaults';
import useVaults from '@/application/read/vaults/useVaults';
import { V2Position } from '@/core/migrate';
import { useEffect, useState } from 'react';
import MigrateInventory from './MigrateInventory';
import { SpinnerGap } from '../../elements/Icon/icons/SpinnerGap';
import { useModalContext } from '@/presentation/context/modal';

const MigrateInventoryContainer = ({ position }: { position: V2Position }) => {
  const { showMigrateVTokenModal, showMigrateXTokenModal } = useModalContext();
  const { data: v2Vaults } = useV2Vaults();
  const { data: allVaults } = useVaults();
  const v2Vault =
    v2Vaults &&
    position &&
    v2Vaults.find((vault) => vault.vaultId === position.vaultId);
  const vaultIds = position.migrateOptions.map((option) => option.vaultId);
  const vaults = allVaults?.filter((v) => vaultIds.includes(v.vaultId));
  const [v3VaultId, setV3VaultId] = useState('');

  useEffect(() => {
    if (vaults?.length && !v3VaultId) {
      setV3VaultId(vaults[0].vaultId);
    }
  }, [v3VaultId, vaults]);

  if (!position || !v2Vault || !vaults) {
    return (
      <div className="p-6 flex justify-center items-center">
        <SpinnerGap className="animate-spin h-6 w-6" />
      </div>
    );
  }

  const onSubmit = () => {
    if (position.type === 'vToken') {
      showMigrateVTokenModal({
        positionId: position.id,
        v3VaultId,
      });
    } else {
      showMigrateXTokenModal({
        positionId: position.id,
        v3VaultId,
      });
    }
  };

  return (
    <MigrateInventory
      onSubmit={onSubmit}
      position={position}
      setV3VaultId={setV3VaultId}
      v2Vault={v2Vault}
      v3VaultId={v3VaultId}
      vaults={vaults}
    />
  );
};

export default MigrateInventoryContainer;
